// src/components/ClientLink.mjs
import React from 'react';
import { Link, useParams } from 'react-router-dom';

const ClientLink = ({ to, children, ...props }) => {
    const { clientName } = useParams();
    
    // Remove barra inicial se existir para evitar dupla barra
    const cleanPath = to.startsWith('/') ? to.slice(1) : to;
    const clientPath = `/${clientName}/${cleanPath}`;
    
    return (
        <Link to={clientPath} {...props}>
            {children}
        </Link>
    );
};

export default ClientLink;
